import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { hexToRgba } from '../../generalContent/utils/generalContent';
interface CssProps {
  isMenuOpen?: boolean;
  isAnimating?: boolean;
}
export const MenuDialogStyles = makeStyles<CssProps>()((theme: Theme, props) => ({
  menuDialogWrapper: {
    paddingLeft: '5rem',
    width: '20%',
    zIndex: 50,
    '& .MuiList-root': {
      background: `${hexToRgba(`${theme.palette.primary.contrastText}`, 90)}`,
      boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15)',
      borderRadius: '6px',
      padding: '1.25rem',
      [theme.breakpoints.down('lg')]: {
        padding: '1.875rem',
        borderRadius: '1rem',
      },
      border: 'none',
      '& > li:first-child': {
        paddingTop: '0px',
      },
      '& .MuiListItem-root': {
        paddingTop: '1.5rem',
        [theme.breakpoints.down('lg')]: {
          minHeight: '2.5rem',
          paddingTop: '0px !important',
        },
      },
      '& .MuiListItem-button:hover': {
        textDecoration: 'none',
        background: 'none',
      },
      '& .MuiListItem-gutters': {
        paddingLeft: 0,
        paddingRight: 0,
      },
      '& .MuiMenuItem-root:hover': {
        textDecoration: 'none',
        background: 'none',
      },
      '& .MuiMenuItem-root': {
        wordBreak: 'break-word',
        color: `${theme.palette.primary.main}`,
        textDecoration: 'underline',
        fontSize: '1rem',
        fontWeight: 600,
        linHeight: '1.375rem',
        whiteSpace: 'unset',
        paddingBottom: 0,
      },
    },
  },
  boxPositionFixed: {
    positon: 'fixed',
  },
  boxPositionAbsolute: {
    positon: 'absolute',
  },
  mobileWrapper: {
    alignItems: 'flex-end',
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    '& > button': {
      position: 'fixed',
      zIndex: 201,
      bottom: 32,
      right: 15,
      [theme.breakpoints.up('sm')]: {
        bottom: 40,
        right: 40,
      },
      height: '3.5rem',
      minWidth: '3.5rem',
      color: `${theme.palette.primary.main} !important`,
      background:
        props.isMenuOpen && !props.isAnimating
          ? 'none !important'
          : `${hexToRgba(`${theme.palette.primary.contrastText}`, 90)} !important`,
      borderRadius: '50%',
      boxShadow: `10px 10px 20px 0px ${hexToRgba(theme.palette.primary.main, 30)}`,
    },
  },
  mobileMenuWrapper: {
    position: 'fixed',
    zIndex: 200,
    bottom: 32,
    right: 15,
    width: 'calc(100% - 1.875rem)',
    [theme.breakpoints.up('sm')]: {
      width: '51% !important',
      bottom: 40,
      right: 40,
      paddingLeft: '0',
    },
  },
  defaultAnimation: {
    opacity: '0 !important',
    display: 'none',
  },
  animationIn: {
    willChange: 'transform',
    transformOrigin: 'bottom right',
    animation: '$animationIn 700ms ease',
    opacity: 1,
    borderRadius: '1rem',
  },
  animationOut: {
    animation: `$animationOut 500ms ease-in`,
    transformOrigin: 'right bottom',
    willChange: 'transform',
    opacity: 1,
  },
  '@keyframes animationIn': {
    '0%': { transform: 'translateY(0) scale3d(0.1,0.1,.1)' },
    '50%': { transform: 'translateY(0) scale3d(1.04,1.04,1.04)' },
    '100%': { transform: 'translate(0, 0) scale3d(1,1,1);' },
  },

  '@keyframes animationOut': {
    '0%': {
      opacity: '1 !important',
      transform: 'translate(0, 0) scale3d(1,1,1);',
    },
    '100%': {
      borderRadius: '50% 50% 25% 50%',
      opacity: '1 !important',
      transform: 'translate(0, 0) scale3d(0.13,0.13,0.13)',
    },
  },
}));
